import { Button } from '@cleartax/wg-library-button';
import { If } from '@cleartax/wg-library-conditionals';
import { SkeletonLoader } from '@cleartax/wg-library-loader';
import { Text } from '@cleartax/wg-library-typography';
import { CLEARTAX_DOMAIN } from '../../../../../../../config/constants';
import { trackAction } from '../../../../../../../shared';
import {
  getCommaFormat,
  getCurrencyFromUnicode
} from '../../../../../../../shared/utils/utils/index';
import { usePlanCtx } from '../../../planDetailsContext';
import { getPercentageDiff } from '../../../utils';

export const StickyPriceCard: React.FC = () => {
  const { seoSlug, name, amountSymbol, listingId, getPlanPriceDetailsApi } =
    usePlanCtx();

  const { totalAmount, tax, originalPrice } = getPlanPriceDetailsApi.data;
  const discountedPrice = totalAmount - tax;
  const discountPercentage = getPercentageDiff(originalPrice, discountedPrice);

  return (
    <div
      style={{
        boxShadow: '0px 5.00421px 5.00421px rgba(0, 0, 0, 0.1)',
      }}
      className="w-full bg-grey-100 flex items-center h-32 rounded-3xl sticky bottom-0.5 sm:h-auto sm:py-5 sm:bottom-0"
    >
      <div className="wg-container w-full flex justify-between items-center sm:flex-col">
        <div className="w-1/2 sm:w-full">
          <Text
            textSize="2xl"
            className="text-brand-1000 w-full sm:text-s-14 sm:font-semibold"
            weight="bold"
          >
            {name}
          </Text>
        </div>
        <div className="flex w-1/2 justify-end items-center sm:w-full sm:justify-between">
          <div className="pr-8 sm:flex sm:pr-0 sm:items-center w-1/3 sm:w-1/2">
            <SkeletonLoader isLoading={getPlanPriceDetailsApi.isLoading}>
              <Text
                textSize="4xl"
                className="text-brand-1000 pt-4 sm:text-s-20 sm:pt-0 sm:pr-2 whitespace-nowrap"
                weight="bold"
              >
                {!getPlanPriceDetailsApi.isLoading
                  ? `${getCurrencyFromUnicode(amountSymbol)}${getCommaFormat(
                      discountedPrice
                    )}`
                  : '$1,000'}
              </Text>
            </SkeletonLoader>
            <SkeletonLoader isLoading={getPlanPriceDetailsApi.isLoading}>
              <div className="flex pt-2 items-center text-center justify-center sm:pt-0">
                <If condition={!!originalPrice}>
                  <Text className="text-grey-700 line-through decoration-red-600 whitespace-nowrap">
                    {!getPlanPriceDetailsApi.isLoading
                      ? `${getCurrencyFromUnicode(amountSymbol)}
                      ${getCommaFormat(originalPrice)}`
                      : '$1,000'}
                  </Text>
                  <Text
                    weight="extrabold"
                    className="text-red-600 pl-2 whitespace-nowrap"
                  >
                    {`(${discountPercentage}% OFF)`}
                  </Text>
                </If>
              </div>
            </SkeletonLoader>
          </div>

          <Text
            type="a"
            textSize="lg"
            href={`${CLEARTAX_DOMAIN}/checkout/${listingId}`}
          >
            <Button
              variant="blue"
              rounded="lg"
              className="px-12 py-5 sm:text-base sm:px-5 sm:py-1"
              onClick={() => {
                trackAction('click', '', {
                  label: `buy_now_sticky_bottom_product_page_${seoSlug}`,
                });
              }}
            >
              Buy now
            </Button>
          </Text>
        </div>
      </div>
    </div>
  );
};
